/**
 * Joins class names, leaving out the ones a condition turned off.
 *
 * @param names Class names, or `false`, `null` or `undefined` for one that does not apply.
 * @returns The names that apply, separated by spaces.
 * @example
 * classes("ot-button", pressed && "is-pressed");
 * // "ot-button" when not pressed
 */
export function classes(...names: readonly (string | false | null | undefined)[]): string {
  return names.filter((name): name is string => typeof name === "string" && name.length > 0).join(" ");
}
